/*
* 在任意登录的组件进行继承扩展，不再需要继承baseVueOptions
*/
import baseVueOptions from './BaseVueOptions'
import { win, getQueryString, ismobile } from './CommonUtils'
import cookieUtils from './CookieUtils'
import localStorageUtils from '@/components/dcf/js/LocalStorageUtils'

const CUSTOMER_TYPE = {
  DCF: 'DCF',  // 运营
  ORG: 'ORG',  // 机构
  CORE_CUSTOMER: 'CORE_CUSTOMER',  // 核心企业
  CHAIN_CUSTOMER: 'CHAIN_CUSTOMER'  // 链属企业
}

// 获取权限cookie字符串
function getAuthString (loginInfo) {
  const auth = []
  if (loginInfo) {
    auth.push(loginInfo.authType)
    auth.push('|')
    auth.push(loginInfo.superAdmin ? '1' : '0')
    auth.push('|')

    if (loginInfo.roleIds) {
      auth.push(loginInfo.roleIds.join('`'))
      auth.push('|')
      auth.push(loginInfo.permissionCodes.join('`'))
    }

    return auth.join('')
  } else {
    return null
  }
}

// 获取主域名
function getMainDomain () {
  let mainDomain = null
  const hostName = win.getLocation().hostname
  const domainSplit = hostName.split('.')
  if (domainSplit.length >= 3) {
    var sectionList = []
    var skipStep = domainSplit.length - 2
    for (var i = skipStep; i < domainSplit.length; i++) {
      sectionList.push(domainSplit[i])
    }

    mainDomain = sectionList.join('.')
  } else {
    mainDomain = 'localhost'
  }
  return mainDomain
}

// 服务类型 JQPJ金券票据 区块链
function getServiceCode (service) {
  const code = []
  if (service) {
    for (let i = 0; i < service.length; i++) {
      code.push(service[i].serviceCode)
    }
  }

  return code.join('|')
}

// 向cookie里面写入用户登录信息
function setCookies (loginInfo, isSwitch) {
  const mainDomain = getMainDomain()
  const customizedLogo = getQueryString('c')

  cookieUtils.set('auth', getAuthString(loginInfo), {
    domain: mainDomain
  })
  cookieUtils.set('serviceCode', getServiceCode(loginInfo.customerServiceList), {
    domain: mainDomain
  })
  cookieUtils.set('tk', loginInfo.token, {
    domain: mainDomain
  })
  cookieUtils.set('userKey', loginInfo.userId, {
    domain: mainDomain
  })
  cookieUtils.set('cellphone', loginInfo.cellphone, {
    domain: mainDomain
  })
  cookieUtils.set('customerName', encodeURI(loginInfo.customerName), {
    domain: mainDomain
  })
  if (loginInfo.project) {
    cookieUtils.set('contractIds', loginInfo.project.contractId, {
      domain: mainDomain
    })
    cookieUtils.set('projectName', escape(loginInfo.project.projectName) || '', {
      domain: mainDomain
    })
    if (loginInfo.project.role === 1) { // 核心
      if (loginInfo.project.isBuyer) {
        cookieUtils.set('currentRole', 'coreBuyer', {
          domain: mainDomain
        })
      } else {
        cookieUtils.set('currentRole', 'coreSaller', {
          domain: mainDomain
        })
      }
    } else if (loginInfo.project.role === 2) { // 链属
      if (loginInfo.project.isBuyer) {
        cookieUtils.set('currentRole', 'chainBuyer', {
          domain: mainDomain
        })
      } else {
        cookieUtils.set('currentRole', 'chainSaller', {
          domain: mainDomain
        })
      }
    }
  }
  if (!isSwitch) {
    cookieUtils.set('coreLogo', customizedLogo, {
      domain: mainDomain
    })
    if (window.top !== window) {
      const redirectUrl = decodeURIComponent(getQueryString('backUrl'))
      cookieUtils.set('redirectUrl', redirectUrl, {
        domain: mainDomain
      })
    }
  }
}

// 更新用户和企业信息
function refreshStorage (info) {
  localStorageUtils.set('userName', info.userName)
  localStorageUtils.set('customerName', info.customerName)
  localStorageUtils.set('customerId', info.customerId)
  if (info.project) {
    localStorageUtils.remove('projectName')
    localStorageUtils.remove('contractIds')
    localStorageUtils.remove('projectTime')
    localStorageUtils.set('projectName', info.project.projectName)
    localStorageUtils.set('contractIds', info.project.contractId)
    localStorageUtils.set('projectTime', info.project.createTime)
  }
}

// 核心根据项目情况路由到不同页面
function getProject (vm) {
  vm.ajax({
    url: '/api/contract/getProject?timestamp=' + new Date().getTime(),
    type: 'GET',
    success (res) {
      const data = res.body
      if (data.ret === 1 && data.result) {
        const projectList = data.result || []
        const result = data.result
        if (projectList.length === 1) {
          // 如果只有一个项目，直接选定
          localStorageUtils.set('projectName', result[0].projectName || '')
          localStorageUtils.set('contractIds', result[0].coreContractIdList.join(','))
          localStorageUtils.set('projectTime', result[0].createTime)
          // 如果是核心卖家角色
          if (!result[0].isBuyer) {
            goTo('/dcf/core1N.html#/index')
          } else {
            goTo(vm.homeHostUrl + '/view/')
          }
        } else {
          // 如果多个项目，跳转到选项目页面
          goTo('/dcf/core1N.html#/project')
        }
      }
    }
  })
}

// 核心选择首页
function coreSelectIndex (vm, info) {
  if (info.project) {
    if (info.project.role === 1) { // 核心
      if (info.project.isBuyer) {
        goTo(vm.homeHostUrl + '/view/')
      } else {
        goTo('/dcf/core1N.html#/index')
      }
    }
    return
  }
  // 判断本次登录用户是否和上次一致
  const isBeforeCustomer = (localStorageUtils.get('customerId') === info.customerId)

  const originUrl = getQueryString('os_destination')
  // 如果客户id和上次一致，跳转到用户原始访问页 否则必须要重新选择项目
  if (isBeforeCustomer && originUrl) {
    window.location.href = originUrl + (window.location.hash || '')
    return
  } else {
    // 清除上一次的项目信息
    localStorageUtils.remove('projectName')
    localStorageUtils.remove('contractIds')
    localStorageUtils.remove('projectTime')
  }
  vm.ajax({
    url: '/v1/loan/customer/get',
    type: 'GET',
    success: function (res) {
      const data = res.body
      if (data.ret === 1 && data.result) {
        const result = data.result
        // 合并授权合同
        const contractList = (result.contractList || []).concat(result.authorizationContractList || [])
        if (contractList && contractList.length > 0) {
          // 角色判断 允许多角色
          const customerRole = []
          for (let contract of contractList) {
            if (contract.isCore && contract.isBuyer) {
              customerRole.push('coreBuyer')
            } else if (contract.isCore && !contract.isBuyer) {
              customerRole.push('coreSeller')
            } else if (!contract.isCore && contract.isBuyer) {
              customerRole.push('chainBuyer')
            } else if (!contract.isCore && !contract.isBuyer) {
              customerRole.push('chainSeller')
            }
          }
          localStorageUtils.set('customerRole', customerRole.join('|'))
          // 如果有核心卖家角色
          if (customerRole.indexOf('coreSeller') > -1) {
            getProject(vm)
          } else {
            goTo(vm.homeHostUrl + '/view/')
          }
        } else {
          // 没有合同 暂时先到1+N的首页
          goTo('/dcf/core1N.html#/index')
        }
      }
    }
  })
}

function goTo (url) {
  const customizedLogo = getQueryString('c')
  const openInCurrentPage = getQueryString('o')

  if (url.indexOf('http') !== 0) {
    url = window.location.origin + url
  }

  if (customizedLogo && openInCurrentPage) {
    window.location.href = url
  } else {
    try {
      const topDomain = window.top.location.hostname.split('.').slice(1).join('.')
      const tmpUrl = url.split('.').slice(1).join('.')

      if (tmpUrl.indexOf(topDomain) !== 0 && window.top.location.hostname !== 'localhost') {
        window.location.href = url
      } else {
        window.location.href = url
      }
    } catch (e) {
      window.location.href = url
    }
  }
}

export default {
  extends: baseVueOptions,
  methods: {
    loginResolve (result, isSwitch) {
      const vm = this
      refreshStorage(result)
      setCookies(result, isSwitch)
      if (!isSwitch) {
        if (result.listCustomerSize > 0 || !result.customerType || result.hasNewCustomers || ismobile()) {
          // 进入企业列表
          goTo('/dcf/minisite.html#/bind_customer')
          return
        }
      }
      switch (result.customerType) {
        case CUSTOMER_TYPE.DCF:
          if (vm.$alert) {
            vm.$alert('请到运营端登录', '提示', {
              confirmButtonText: '确定'
            })
          } else if (typeof (vm.errorMsg1) !== 'undefined') {
            // 官网登录
            vm.errorMsg1 = '请到运营端登录'
            vm.isShowMsg1 = true
          } else {
            alert('请到运营端登录')
          }
          break
        case CUSTOMER_TYPE.ORG:
          // 跳转到机构主页
          goTo(vm.homeHostUrl + '/views/institution/index.jsp')
          break
        case CUSTOMER_TYPE.CORE_CUSTOMER:
          coreSelectIndex(vm, result)
          break
        case CUSTOMER_TYPE.CHAIN_CUSTOMER:
          // 进入链属首页
          goTo(vm.homeHostUrl + '/view/')
          break
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/LoginResolve.js